import Service from "./common.services";

/**
 * Requests a URL, returning a promise
 * @return {object} The response data
 */
export default function request<T>(args: any): object {
  const CommonService = new Service<T>();
  if (args[1] === "TERMS_AND_CONDITION") {
    return CommonService.get(args[0], args[1]);
  } else if (args[1] === "UPDATE_DELETE_NOTIFICATION") {
    return CommonService.put(
      args[0],
      args[1],
      args[2],
      args[3],
    );
  } else {
    return CommonService.post(
      args[0],
      args[1],
      args[2],
      args[3],
    );
  }
}
